<template>
<!-- 卡申请详情 -->
  <div class="content">
    <!-- 基本信息区域 -->
    <el-card class="info-card" shadow="hover">
      <div slot="header" class="info-header">
        <h3>申请基本信息</h3>
      </div>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="订单号">{{applicationInfo.orderNum}}</el-descriptions-item>
        <el-descriptions-item label="申请类型">
            <el-tag type="danger">{{applicationInfo.type == '1' ? 'SIM' : 'ESIM'}}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="邮箱" v-if="applicationInfo.type=='2'">{{applicationInfo.email}}</el-descriptions-item>
        <template v-if="applicationInfo.type =='1'">
            <el-descriptions-item label="物流单号">{{applicationInfo.logisticNo}}</el-descriptions-item>
            <el-descriptions-item label="物流公司">{{applicationInfo.logisticCompany}}</el-descriptions-item>
            <el-descriptions-item label="联系人">{{applicationInfo.contactMan}}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{applicationInfo.contactPhone}}</el-descriptions-item>
            <el-descriptions-item label="联系地址">{{applicationInfo.contactAddr}}</el-descriptions-item>
        </template>
        <el-descriptions-item label="状态">
            <template v-if="applicationInfo.type == '2'">
                <el-tag  type="warning" v-if="applicationInfo.status == '0'">失败</el-tag>
                <el-tag  v-if="applicationInfo.status == '1'">发送中</el-tag>
                <el-tag type="success" v-if="applicationInfo.status == '2'">已发送</el-tag>
                <el-tag type="danger" v-if="applicationInfo.status == '3'">已退款</el-tag>
            </template>
            <template v-else>
              <el-tag type="warning" v-if="applicationInfo.status == '0'">未发货</el-tag>
              <el-tag  v-if="applicationInfo.status == '1'">待发货</el-tag>
              <el-tag type="success" v-if="applicationInfo.status == '2'">已发货</el-tag>
              <el-tag type="danger" v-if="applicationInfo.status == '3'">已退款</el-tag>
            </template>
        </el-descriptions-item>
        <el-descriptions-item label="申请数量">{{applicationInfo.cardNum}}张</el-descriptions-item>
        <el-descriptions-item label="实际分配数量">{{applicationInfo.actualNum}}张</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{applicationInfo.createTime}}</el-descriptions-item>
        <el-descriptions-item label="订单金额(含快递费)">{{applicationInfo.orderMoney}} {{applicationInfo.currency}}</el-descriptions-item>
        <el-descriptions-item label="快递费">{{applicationInfo.expressFee}} {{applicationInfo.currency}}</el-descriptions-item>
        <el-descriptions-item label="支付渠道">{{transferScene(applicationInfo.scene)}}</el-descriptions-item>
        <el-descriptions-item label="备注">{{applicationInfo.rmk}}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <!-- 记录信息标签页 -->
    <el-card class="record-card" shadow="hover" style="margin-top: 20px;">
      <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick">
        <el-tab-pane label="卡订单记录" name="cardRecord">
          <el-table :data="cardOrderRecords" style="width: 100%">
            <el-table-column prop="iccid" align="center" label="卡号" width="200"></el-table-column>

            <el-table-column prop="orderNum" align="center" label="订单号" width="200"></el-table-column>
            <el-table-column prop="paymentTime" align="center" label="支付时间" width="150"></el-table-column>
            <el-table-column prop="orderStatus" align="center" label="订单状态" width="150"></el-table-column>
            <el-table-column prop="accountMoney" align="center" label="订单金额" width="150">
                <template slot-scope="scope">
                    {{scope.row.accountMoney}}  {{scope.row.currency}}
                </template>
            </el-table-column>
            <el-table-column prop="outOrderNum" align="center" label="父订单号" width="200"></el-table-column>
            <el-table-column prop="productName" align="center" label="产品名称" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="groupName" align="center" label="使用区域" width="150"></el-table-column>
            <el-table-column prop="operation" align="center" label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="!scope.row.iccid" size="mini" @click="simDistribution(scope.row.orderNum)">分配卡</el-button>
                </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="卡邮件记录" name="emailRecord" v-if="applicationInfo.type == '2'">
          <el-table :data="emailRecords" style="width: 100%">
            <el-table-column prop="email" align="center" label="邮箱地址"></el-table-column>
            <el-table-column prop="iccid" align="center" label="卡号"></el-table-column>
            <el-table-column prop="createTime" align="center" label="发送时间"></el-table-column>
            <el-table-column prop="status" align="center" label="发送状态">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.status == '2'">成功</el-tag>
                <el-tag type="danger" v-else>失败</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="operation" align="center" label="操作">
                <template slot-scope="scope">
                    <el-button type="primary"  size="mini" @click="sendEmail(scope.row.iccid,scope.row.orderNum)">重新发送</el-button>

                </template>
            </el-table-column>

          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  <!--分配卡号对话框 -->
    <el-dialog title="分配卡号" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false">

      <el-form :model="formData" :rules="rules" ref="formRef">
        <el-form-item label="订单号" prop="orderNum">
          <el-input v-model="formData.orderNum" disabled></el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="iccid">
          <el-input v-model="formData.iccid" placeholder="请输入卡号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitDistribution">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { internationalApplicationInfo,internationalApplicationOrderList,internationalMailRecordList , simDistribution ,simSendEmail} from "@/api/international.js";

  export default {
    name: 'internationalApplicationInfo',
    data () {
      return {
        activeTab: 'cardRecord',
        cardOrderRecords: [],
        emailRecords: [],
        applicationInfo: {
          applicationNo: '',
          applicant: '',
          applyTime: '',
          status: '',
          cardType: '',
          applyQuantity: 0
        },
        dialogVisible: false,
        formData: {
          orderNum: '',
          iccid: ''
        },
        rules: {
          iccid: [
            { required: true, message: '请输入卡号', trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      
    },
    methods: {
        initApplicationInfo(){
          internationalApplicationInfo({
            id: this.$route.params && this.$route.params.id
          }).then(res => {
            this.applicationInfo = res.data.data
          })
        },
        initCardOrderRecords(){
          internationalApplicationOrderList({
            id: this.$route.params && this.$route.params.id
          }).then(res => {
            this.cardOrderRecords = res.data.data
          })
        },
        initEmailRecords(){
          internationalMailRecordList({
            id: this.$route.params && this.$route.params.id
          }).then(res => {
            this.emailRecords = res.data.data
          })
        },
        handleTabClick(tab){
          this.activeTab = tab.name
          if(this.activeTab == 'cardRecord'){
            this.initCardOrderRecords()
          }else if(this.activeTab == 'emailRecord'){
            this.initEmailRecords()
          }

        },
        //打开分配卡对话框
        simDistribution(orderNum) {
          this.formData.orderNum = orderNum;
          this.formData.iccid = ''
          this.formData.id = this.$route.params && this.$route.params.id;
          this.dialogVisible = true;
        },
        // 提交分配卡
        submitDistribution() {
          this.$refs.formRef.validate((valid) => {
            if (valid) {
              simDistribution(this.formData).then(res => {
                if (res.data.code === 200) {
                  this.$message.success('分配成功');
                  this.dialogVisible = false;
                  this.initApplicationInfo()
                  // 重新加载订单列表
                  this.initCardOrderRecords();
                } else {
                  this.$message.error(res.data.msg || '分配失败');
                }
              })
            }
          });
        },
        //重新发送重新发送邮件
        sendEmail(iccid,orderNum){
          simSendEmail({
            iccid: iccid,
            orderNum: orderNum
          }).then(res => {
            if (res.data.code === 200) {
              this.$message.success('重新发送成功');
              // 重新加载邮件列表
              this.initEmailRecords();
            } else {
              this.$message.error(res.data.msg || '重新发送失败');
            }
          })
        },
        transferScene(scene) {
          if(!scene){
            return ""
          }
          let obj = {
            "h5": "H5",
            "web": "网页",
            "website": "国际站",
            "wechat": "公众号",
            "wcMini": "智汇桔小程序",
            "intMini": "国际环球流量小程序",
          };
          return obj[scene];
        },
    },
    mounted () {
      this.initApplicationInfo()
      this.initCardOrderRecords()
      this.initEmailRecords() 
    },
  };
</script>
<style scoped lang="less">
.content {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.info-card {
  margin-bottom: 20px;
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  
  h3 {
    margin: 0;
    color: #333;
    font-size: 16px;
  }
}

.record-card {
  .el-tabs__content {
    padding: 15px;
  }
}

/deep/ .el-descriptions__label {
  font-weight: 500;
}

/deep/ .el-card__body {
  padding: 20px;
}
</style>
